import React from 'react';
import {Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

/* ── Status chip ────────────────────────────────────────────────── */
const PROD_STATUS = {
    'Active':             {bg: 'var(--brand-surface-subtle, #E8F5F0)', color: TEAL},
    'Growth opportunity': {bg: 'var(--brand-surface-subtle, #DBEAFE)', color: '#2563EB'},
};

const StatusChip = ({label}) => {
    const s = PROD_STATUS[label] || {bg: 'var(--brand-surface-muted, #F3F4F6)', color: '#4B5563'};
    return (
        <Box sx={{
            display: 'block',
            width: '100%',
            backgroundColor: s.bg,
            color: s.color,
            fontSize: '13px',
            fontWeight: 600,
            textAlign: 'center',
            py: 0.8,
            borderRadius: '20px',
        }}>
            {label}
        </Box>
    );
};

/* ── Shared cell styles ─────────────────────────────────────────── */
const headCell = {
    backgroundColor: NAVY,
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 700,
    borderBottom: 'none',
    py: 2,
    px: 2.5,
};

const bodyCell = {
    fontSize: '14px',
    color: '#374151',
    py: 2,
    px: 2.5,
    borderBottom: '1px solid #F3F4F6',
};

/* ── Table data ─────────────────────────────────────────────────── */
const ROWS = [
    {
        product:  'COS Children Assessment',
        reach:    '1,840 schools',
        users:    '412k',
        adoption: '398k assessments',
        signal:   'Core · renewing',
        status:   'Active',
    },
    {
        product:  'COS Parent Assessment',
        reach:    '1,210 schools',
        users:    '86k',
        adoption: '66% of schools',
        signal:   'Expansion opportunity',
        status:   'Growth opportunity',
    },
    {
        product:  'COS Teacher Assessment',
        reach:    '1,640 schools',
        users:    '14.2k',
        adoption: '89% of schools',
        signal:   'Stable',
        status:   'Active',
    },
    {
        product:  'COS School Leader Assessment',
        reach:    '1,840 schools',
        users:    '1,840',
        adoption: 'all schools',
        signal:   'Stable',
        status:   'Active',
    },
];

const PackageUptakeTab = () => (
    <Box>
        <TableContainer sx={{
            border: '1px solid var(--brand-border, #E5E7EB)',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{...headCell, width: '30%'}}>Product / package</TableCell>
                        <TableCell sx={{...headCell, width: '18%'}}>Reach</TableCell>
                        <TableCell sx={{...headCell, width: '14%'}}>Active users</TableCell>
                        <TableCell sx={{...headCell, width: '18%'}}>Adoption</TableCell>
                        <TableCell sx={{...headCell, width: '20%', textAlign: 'center'}}>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ROWS.map((row, i) => (
                        <TableRow key={row.product} sx={{backgroundColor: i % 2 === 0 ? 'var(--brand-surface, #ffffff)' : 'var(--brand-surface-subtle, #F9FAFB)'}}>
                            <TableCell sx={{...bodyCell, fontWeight: 700, color: NAVY}}>{row.product}</TableCell>
                            <TableCell sx={bodyCell}>{row.reach}</TableCell>
                            <TableCell sx={bodyCell}>{row.users}</TableCell>
                            <TableCell sx={bodyCell}>{row.adoption}</TableCell>
                            <TableCell sx={{...bodyCell, px: 1.5}}>
                                <StatusChip label={row.status}/>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

        {/* Recommended action footer */}
        <Box sx={{
            mt: 3,
            p: {xs: 2, md: 2.5},
            backgroundColor: 'var(--brand-surface-subtle, #F0F7F4)',
            border: '1px solid #C6E0D8',
            borderLeft: `4px solid ${TEAL}`,
            borderRadius: '0 8px 8px 0',
        }}>
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                <strong style={{color: TEAL}}>Recommended action:&nbsp;</strong>
                Lead expansion with the Parent Pack (66% of schools) and the Government Pack (3 of 5 countries) —
                both warm because the Children Pack is already deployed. Bundle into renewal conversations.
            </Typography>
        </Box>
    </Box>
);

export default PackageUptakeTab;
